const getMenu = (usuario) => {

    const secciones = {
        'admins': {
            label: "Admins",
            icon: "fa-fw fas fa-crown",
        },
        'clientes': {
            label: "Clientes",
            icon: "fa-fw fas fa-sitemap",
            alertas: ['vencimientos_documentacion_clientes'],
            pendientes: ['validar_documentacion_clientes'],
        },
        'proveedores': {
            label: "Proveedores",
            icon: "fa-fw fas fa-briefcase",
            alertas: ['vencimientos_documentacion_proveedores'],
            pendientes: ['validar_documentacion_proveedores'],
        },
        'usuarios': {
            label: "Usuarios",
            icon: "fa-fw fas fa-users",
            alertas: ['solicitudes', 'vencimientos_documentacion_usuarios'],
            pendientes: ['validar_documentacion_usuarios'],
        },
        'comunicacion': {
            label: "Comunicación y Ayuda",
            icon: "fa-fw fas fa-satellite-dish",
            pendientes: ['mensajes'],
        },
        // 'consumos': {
        //     label: "Consumos",
        //     icon: "fa-fw fas fa-cash-register",
        //     to: "/consumos",
        // },
        'pur': {
            label: "Pantalla Unificada de Reportes",
            icon: "fa-fw fas fa-cash-register",
            to: "/pur",
        },
        'documentacion': {
            label: "Tipos de Documentos",
            icon: "fa-fw fas fa-file-alt",
            to: "/documentos/tipos",
        },
        'vehiculos': {
            label: "Vehículos",
            icon: "fa-fw fas fa-car",
            to: "/vehiculos/admin",
        },
    }

    const modulos = {
        admins_admin: {
            label: "Administrar",
            icon: "fa-fw fas fa-user-edit",
            to: "/admins/admin",
            parent: "admins",
        },
        clientes_admin: {
            label: "Administrar Clientes",
            icon: "fa-fw fas fa-boxes",
            to: "/clientes/admin",
            parent: "clientes",
        },
        clientes_managers: {
            label: "Administrar Managers",
            icon: "fa-fw fas fa-user-edit",
            to: "/clientes/managers",
            parent: "clientes",
        },
        clientes_tipos: {
            label: "Tipos de Clientes",
            icon: "fa-fw fas fa-sitemap",
            to: "/clientes/tipos",
            parent: "clientes",
        },
        clientes_validar: {
            label: "Validar documentación",
            icon: "fa-fw fas fa-clipboard-check",
            to: "/clientes/validar",
            parent: "clientes",
            pendientes: ['validar_documentacion_clientes'],
        },
        clientes_vencimientos: {
            label: "Vencimientos documentación",
            icon: "fa-fw far fa-clock",
            to: "/clientes/vencimientos",
            parent: "clientes",
            alertas: ['vencimientos_documentacion_clientes'],
        },
        proveedores_admin: {
            label: "Administrar Proveedores",
            icon: "fa-fw fas fa-list",
            to: "/proveedores/admin",
            parent: "proveedores",
        },
        proveedores_managers: {
            label: "Administrar Managers",
            icon: "fa-fw fas fa-user-edit",
            to: "/proveedores/managers",
            parent: "proveedores",
        },
        proveedores_pdv: {
            label: "Puntos de Venta",
            icon: "fa-fw fas fa-store",
            to: "/proveedores/pdv",
            parent: "proveedores",
        },
        proveedores_tipos: {
            label: "Tipos de Proveedores",
            icon: "fa-fw fas fa-briefcase",
            to: "/proveedores/tipos",
            parent: "proveedores",
        },
        proveedores_validar: {
            label: "Validar documentación",
            icon: "fa-fw fas fa-clipboard-check",
            to: "/proveedores/validar",
            parent: "proveedores",
            pendientes: ['validar_documentacion_proveedores'],
        },
        proveedores_vencimientos: {
            label: "Vencimientos documentación",
            icon: "fa-fw far fa-clock",
            to: "/proveedores/vencimientos",
            parent: "proveedores",
            alertas: ['vencimientos_documentacion_proveedores'],
        },
        usuarios_admin: {
            label: "Administrar Usuarios",
            icon: "fa-fw fas fa-user-edit",
            to: "/usuarios/admin",
            parent: "usuarios",
        },
        usuarios_tipos: {
            label: "Tipos de Usuarios",
            icon: "fa-fw fas fa-users",
            to: "/usuarios/tipos",
            parent: "usuarios",
        },
        usuarios_validar: {
            label: "Validar documentación",
            icon: "fa-fw fas fa-clipboard-check",
            to: "/usuarios/validar",
            parent: "usuarios",
            pendientes: ['validar_documentacion_usuarios'],
        },
        usuarios_vencimientos: {
            label: "Vencimientos documentación",
            icon: "fa-fw far fa-clock",
            to: "/usuarios/vencimientos",
            parent: "usuarios",
            alertas: ['vencimientos_documentacion_usuarios'],
        },
        usuarios_importar: {
            label: "Importar Usuarios",
            icon: "fa-fw fas fa-file-upload",
            to: "/usuarios/importar",
            parent: "usuarios",
        },
        usuarios_solicitudes_credito: {
            label: "Solicitudes de Crédito",
            icon: "fa-fw fas fa-dollar-sign",
            to: "/usuarios/solicitudes_credito",
            parent: "usuarios",
            alertas: ['solicitudes']
        },
        ayuda_categorias: {
            label: "Ayuda -> Categorias",
            icon: "fa-fw fas fa-list",
            to: "/ayuda/categorias",
            parent: "comunicacion",
        },
        ayuda_contenidos: {
            label: "Ayuda -> Contenidos",
            icon: "fa-fw far fa-file-alt",
            to: "/ayuda/contenidos",
            parent: "comunicacion",
        },
        notificaciones: {
            label: "Notificaciones",
            icon: "fa-fw fas fa-bell",
            to: "/notificaciones",
            parent: "comunicacion",
        },
        soporte_mensajes: {
            label: "Mensajes de soporte",
            icon: "fa-fw fas fa-comment",
            to: "/soporte/mensajes",
            parent: "comunicacion",
            pendientes: ['mensajes'],
        },
        tycs: {
            label: "Términos y Condiciones",
            icon: "fa-fw fas fa-file-alt",
            to: "/tycs",
            parent: "comunicacion",
        },
    };

    const menu = [
        {
            label: "Inicio",
            icon: "fa-fw fas fa-home",
            to: "/",
        },
    ];

    if (usuario.nivel === 1 || usuario.nivel === 2) {

        const seccionesIds = Object.keys(secciones);

        for (let x = 0; x < seccionesIds.length; x++) {
            const seccionId = seccionesIds[x];

            // console.log(`seccionId: ${seccionId}`);

            const modulosIds = Object.keys(modulos).filter(modulo => modulos[modulo].parent === seccionId);

            // console.log(modulosIds);

            let modulosSeccion = [];

            if (typeof secciones[seccionId].to === 'undefined') {
                if (usuario.nivel === 1) {
                    modulosSeccion = modulosIds.map(moduloId => modulos[moduloId])
                } else if (usuario.nivel === 2) {
                    if (seccionId !== 'admins') {
                        if (usuario.permisos.todo === true) {
                            modulosSeccion = modulosIds.map(moduloId => modulos[moduloId])
                        } else {
                            modulosSeccion = modulosIds.filter(moduloId => usuario.permisos.modulos.some(modulo => modulo.id === moduloId && (modulo.read === true || modulo.write === true))).map(moduloId => modulos[moduloId])
                        }
                    }
                }
                if (modulosSeccion.length > 0) {
                    menu.push({
                        label: secciones[seccionId].label,
                        icon: secciones[seccionId].icon,
                        alertas: secciones[seccionId].alertas,
                        pendientes: secciones[seccionId].pendientes,
                        items: modulosSeccion
                    })
                }
            } else {
                if (usuario.nivel === 1 || usuario.permisos.todo || usuario.permisos.modulos.some(modulo => modulo.id === seccionId && (modulo.read === true || modulo.write === true))) {
                    menu.push({
                        label: secciones[seccionId].label,
                        icon: secciones[seccionId].icon,
                        alertas: secciones[seccionId].alertas,
                        pendientes: secciones[seccionId].pendientes,
                        to: secciones[seccionId].to,
                    })

                }
            }


        }

    } else if (usuario.nivel === 3) {
        menu.push({
            label: "Ingresar Documentación",
            icon: "fa-fw fas fa-file-alt",
            to: "/cliente/documentacion",
            alertas: ['ingresar_documentacion'],
        });
        menu.push({
            label: "Usuarios",
            icon: "fa-fw fas fa-users",
            items: [
                {
                    label: "Administrar",
                    icon: "fa-fw fas fa-user-edit",
                    to: "/cliente/usuarios/admin",
                },
                {
                    label: "Validar documentación",
                    icon: "fa-fw fas fa-clipboard-check",
                    to: "/cliente/usuarios/validar",
                    pendientes: ['validar_documentacion_usuarios'],
                },
                {
                    label: "Vencimientos documentación",
                    icon: "fa-fw far fa-clock",
                    to: "/cliente/usuarios/vencimientos",
                    alertas: ['vencimientos_documentacion_usuarios'],
                },
                {
                    label: "Solicitudes de Crédito",
                    icon: "fa-fw fas fa-dollar-sign",
                    to: "/cliente/usuarios/solicitudes_credito",
                    alertas: ['solicitudes']
                },
                {
                    label: "Crédito por defecto",
                    icon: "fa-fw fas fa-dollar-sign",
                    to: "/cliente/usuarios/credito_default",
                },
            ],
            alertas: ['solicitudes', 'vencimientos_documentacion_usuarios'],
            pendientes: ['validar_documentacion_usuarios'],
        });
        menu.push({
            label: "Vehículos",
            icon: "fa-fw fas fa-car",
            to: "/cliente/vehiculos/admin",
        });
        menu.push({
            label: "Pantalla Unificada de Reportes",
            icon: "fa-fw fas fa-cash-register",
            to: "/pur",
        });
    } else if (usuario.nivel === 4) {
        menu.push({
            label: "Ingresar Documentación",
            icon: "fa-fw fas fa-file-alt",
            to: "/proveedor/documentacion",
            alertas: ['ingresar_documentacion'],
        });
        menu.push({
            label: "Puntos de venta",
            icon: "fa-fw fas fa-store",
            to: "/proveedor/pdv",
        });
        menu.push({
            label: "Pantalla Unificada de Reportes",
            icon: "fa-fw fas fa-cash-register",
            to: "/pur",
        });
    } else if (usuario.nivel === 6) {
        menu.push({
            label: "Ingresar Documentación",
            icon: "fa-fw fas fa-file-alt",
            to: "/usuario/documentacion",
            alertas: ['ingresar_documentacion'],
        });
    }

    return menu;
};

export default getMenu;
